/* eslint-disable import/prefer-default-export */

// 'muni', - praha
// 'addr',  - poznanska
// 'ward', - bohnice
// 'quar' - praha 8

// regionalStructure : [{name: "445/13", type: "regional.address"}, {name: "Poznaňská", type: "regional.street"},…]
// 0 : {name: "445/13", type: "regional.address"}
// 1 : {name: "Poznaňská", type: "regional.street"}
// 2 : {name: "Bohnice", type: "regional.municipality_part"}
// 3 : {name: "Praha 8", type: "regional.municipality_part"}
// 4 : {name: "Praha", type: "regional.municipality"}
// 5 : {name: "okres Hlavní město Praha", type: "regional.region"}
// 6 : {name: "kraj Hlavní město Praha", type: "regional.region"}
// 7 : {name: "Česko", type: "regional.country", isoCode: "CZ"}

// export const allowedAddressSources = ['muni', 'addr', 'ward', 'quar', 'stre']
export const allowedAddressSources = [
  'regional.address',
  'regional.street',
  'regional.municipality_part',
  'regional.municipality',
]

// export const nonAccurateSources = ['muni', 'ward', 'quar']
export const nonAccurateSources = [
  'regional.street',
  'regional.municipality_part',
  'regional.municipality',
]

// export const accurateSources = ['addr', 'stre']
export const accurateSources = ['regional.address']

export const suggestTypes = [
  'regional.address',
  'regional.street',
  'regional.municipality_part',
  'regional.municipality',
]

export const GEO_TYPE_CITY = 'regional.municipality'
export const GEO_TYPE_CITY_PART = 'regional.municipality_part' // praha 8 nebo bohnice
export const GEO_TYPE_REGION_OR_DISTRICT = 'regional.region' // kraj (region) nebo okres (dist)
export const GEO_TYPE_STREET = 'regional.street' // bez cisla
export const GEO_TYPE_ADDRESS = 'regional.address' // jen cislo

//  label : "Část obce"
// location : "Zdiby, Česko"
// name : "Brnky"
// position : {lon: 14.40919, lat: 50.15806} lat : 50.15806 lon : 14.40919
//  regionalStructure : [{name: "Brnky", type: "regional.municipality_part"}, {name: "Zdiby", type: "regional.municipality"},…] 0 : {name: "Brnky", type: "regional.municipality_part"} 1 : {name: "Zdiby", type: "regional.municipality"} 2 : {name: "okres Praha-východ", type: "regional.region"} name : "okres Praha-východ" type : "regional.region" 3 : {name: "Středočeský kraj", type: "regional.region"} 4 : {name: "Česko", type: "regional.country", isoCode: "CZ"} type : "regional.municipality_part"
// 0 : {name: "Brnky", type: "regional.municipality_part"}
// 1 : {name: "Zdiby", type: "regional.municipality"}
// 2 : {name: "okres Praha-východ", type: "regional.region"}
// 3 : {name: "Středočeský kraj", type: "regional.region"}
// 4 : {name: "Česko", type: "regional.country", isoCode: "CZ"}
// type : "regional.municipality_part"

/// {
//   "name": "Poznaňská 462/32",
//   "label": "Adresa",
//   "position": {
//       "lon": 14.42057,
//       "lat": 50.12945
//   },
//   "type": "regional.address",
//   "location": "Praha 8 - Bohnice, Česko",
//   "regionalStructure": [
//       {
//           "name": "462/32",
//           "type": "regional.address"
//       },
//       {
//           "name": "Poznaňská",
//           "type": "regional.street"
//       },
//       {
//           "name": "Bohnice",
//           "type": "regional.municipality_part"
//       },
//       {
//           "name": "Praha 8",
//           "type": "regional.municipality_part"
//       },
//       {
//           "name": "Praha",
//           "type": "regional.municipality"
//       },
//       {
//           "name": "okres Hlavní město Praha",
//           "type": "regional.region"
//       },
//       {
//           "name": "kraj Hlavní město Praha",
//           "type": "regional.region"
//       },
//       {
//           "name": "Česko",
//           "type": "regional.country",
//           "isoCode": "CZ"
//       }
//   ],
//   "zip": "181 00"
// }

export const mapMapyResult = (result) => {
  const { regionalStructure } = result

  const city = regionalStructure.find((item) => item.type === GEO_TYPE_CITY)
  const cityPart = regionalStructure
    .filter((item) => item.type === GEO_TYPE_CITY_PART)
    .pop?.()

  const regionAndDistrict = regionalStructure.filter(
    (item) => item.type === GEO_TYPE_REGION_OR_DISTRICT
  )

  const district = regionAndDistrict[0]
  const region = regionAndDistrict[1]

  const street = regionalStructure.find((item) => item.type === GEO_TYPE_STREET)
  const streetNumber = regionalStructure.find(
    (item) => item.type === GEO_TYPE_ADDRESS
  )
  const streetAndNumber = streetNumber
    ? `${street?.name || ''} ${streetNumber?.name}`
    : null

  const res = {
    name: result.name,
    label: result.label,
    location: result.location,
    type: result.type,
    source: result.type,
    latLng: {
      lat: result.position.lat,
      lng: result.position.lon,
    },
    zip: result.zip || 'none',

    city: city
      ? {
          name: city.name,
          type: city.type,
        }
      : null,
    cityPart: cityPart
      ? {
          name: cityPart.name,
          type: cityPart.type,
        }
      : null,
    district: district
      ? {
          name: district.name,
          type: district.type,
        }
      : null,
    region: region
      ? {
          name: region.name,
          type: region.type,
        }
      : null,
    street: street
      ? {
          name: street.name,
          type: street.type,
        }
      : null,
    streetNumber: streetNumber
      ? {
          name: streetNumber.name,
          type: streetNumber.type,
        }
      : null,
    streetAndNumber,
    regionalStructure,
    fullAddress: `${result.name}, ${result.location}, ${
      result.zip ? `, ${result.zip}` : ''
    }`,
    address: streetAndNumber || result.name,
  }

  return res
}
